<template>
 <div>
   <button-gutter>
     <template v-if="scope.row.type !== 127">
     <el-button v-if="scope.row.locked === 1 && (scope.row.status === 4 || scope.row.status === 40 )"
                type="primary"
                size="mini"
                @click="onLocked(scope.row)">解锁
     </el-button>
     <el-button
             v-if="(scope.row.locked === 0 || scope.row.locked === 10) && (scope.row.status === 4 || scope.row.status === 40)"
             type="primary"
             size="mini"
             @click="onLocked(scope.row)">锁定
     </el-button>
     <router-link :to="'/order/review/'+scope.row.orderid" target="_blank">
       <el-button v-if="(scope.row.status !== 4)"
                  type="success"
                  size="mini">查看
       </el-button>
     </router-link>
     <router-link :to="'/order/review/'+scope.row.orderid" target="_blank">
       <el-button v-if="scope.row.status === 4"
                  size="mini">审核
       </el-button>
       <el-button style="margin-top: 6px"
                  v-if="scope.row.status === 5 && scope.row.type !== 8"
                  size="mini">修改审核
       </el-button>
     </router-link>
       <router-link :to="'/order/review/'+scope.row.orderid + '?readonly=on'"
                    target="_blank"
                    v-if="scope.row.status === 4">
         <el-button size="mini">查看</el-button>
         </router-link>
      <router-link :to="'/order/appeal/review-order/'+scope.row.orderid"
              target="_blank"
              v-if="canAuditOrderAppealBtn(scope.row)">
        <el-button size="mini" type="primary">处理申诉</el-button>
      </router-link>
     <el-button
             v-if="(scope.row.status === 2 || scope.row.status === 3)"
             type="danger"
             size="mini"
             @click="onWithdraw(scope.row)">收回
     </el-button>
     <el-button style="margin-top: 6px"
                v-if="scope.row.status === 3 && scope.row.type !== 19"
                type="danger"
                size="mini"
                @click="onFinish(scope.row)">强制完成
     </el-button>
     <el-button style="margin-top: 6px"
                v-if="canResetProcess(scope.row)"
                type="danger"
                size="mini"
                @click="resetProcess(scope.row)">重置进行中
     </el-button>
     <el-button style="margin-top: 6px"
                v-if="(scope.row.status === -1) || scope.row.status === -2"
                type="danger"
                size="mini"
                @click="resetFinish(scope.row)">重置待审核
     </el-button>
     </template>
      <router-link
        v-if="scope.row.type === 127"
        :to="`/order/md/table/${scope.row.taskid}`">
          <el-button type="success"
                    size="mini">查看包含工单
          </el-button>
      </router-link>
   </button-gutter>
 </div>
</template>

<script>

import table from '@core/mixins/table'
import OrderResetProcessForm from '@views/order/components/OrderResetProcessForm.vue'

export default {
  mixins: [table],
  props: {
    scope: Object,
  },
  methods: {
    onLocked (scopeRow) {
      let orderid = scopeRow.orderid
      if (orderid) {
        // 解锁：不需要原因
        if (scopeRow.locked === 1) {
          return request.alert('orderLocked', {orderid: orderid}).then(() => {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
            // 点击锁定 locked改为1，点击解锁改为10
            scopeRow.locked = 10
          })
        }

        // 锁定：弹窗输入原因（可不填）
        return this.$prompt('锁单原因（可不填）', '锁定', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '例如：等待补充材料 / 异常数据核对中',
          inputType: 'textarea',
        }).then(({value}) => {
          return request.alert('orderLocked', {
            orderid: orderid,
            lock_reason: (value == null ? '' : String(value).trim()),
          }).then(() => {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
            scopeRow.locked = 1
          })
        }).catch(() => {})
      }
    },
    onFinish (scopeRow) {
      let orderid = scopeRow.orderid
      if (orderid) {
        this.$confirm('你确定要强制完成任务吗？')
          .then(_ => {
            request.alert('orderFinishEnforce', {orderid: orderid}).then(({data}) => {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              })
              scopeRow.status = 4
            })
          })
          .catch(_ => {})
      }
    },
    resetFinish (scopeRow) {
      let orderid = scopeRow.orderid
      if (orderid) {
        this.$confirm('你确定要重新置为待审核状态吗？')
          .then(_ => {
            request.alert('orderReset2Finish', {orderid: orderid}).then(({data}) => {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              })
              scopeRow.status = 4
            })
          })
          .catch(_ => {})
      }
    },
    async resetProcess (scopeRow) {
      let orderid = scopeRow.orderid
      if (orderid) {
        try {
          const content = this.$createElement(OrderResetProcessForm)
          let hours
          await this.$confirm(content, '重置进行中', {
            closeOnClickModal: false,
            beforeClose (action, instance, done) {
              if (action === 'confirm' && content.componentInstance) {
                hours = content.componentInstance.getValue()
              }
              done()
            },
          })
          await request.alert('orderReset2Process', {orderid: orderid, hours: hours})
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success',
          })
          scopeRow.status = 3
        } catch (_) {}
      }
    },
    onWithdraw (scopeRow) {
      let orderid = scopeRow.orderid
      if (orderid) {
        this.$confirm('是否确认收回？').then(_ => {
          this.$confirm('是否需要补偿零豆?', '', {
            confirmButtonText: '是',
            cancelButtonText: '否',
          }).then(_ => {
            request.alert('orderWithdraw', {orderid: orderid, needCompensation: true}).then(({data}) => {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              })
              scopeRow.status = -1
            })
          }).catch(_ => {
            request.alert('orderWithdraw', {orderid: orderid, needCompensation: false}).then(({data}) => {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              })
              scopeRow.status = -1
            })
          })
        }).catch(_ => {})
      }
    },
    canAuditOrderAppealBtn (row) {
      // 处于申诉中，并且具有审核的UI权限
      return row.status * 1 === 20 && filter.hasPermission(40012)
    },
    canResetProcess (orderDetail) {
      return orderDetail.status * 1 === -1 && filter.hasPermission(40011)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/order/components/buttons/OrderOperationButtons.vue